export default "__VITE_ASSET__8w2LE4su__"